import baseApi from './base';
import { ManifestTag } from '@/modules/services/tags';
import config from '@/lib/config';

interface ManifestResponse {
  Item?: {
    playerVersion: string;
    quizIdentifier: string;
    deleted: boolean;
    SK: string;
    description: string;
    PK: string;
    elearningIdentifier: number;
    title: string;
    elearningType: 'draft' | 'review' | 'live' | 'scorm';
    tenantIdentifier: string;
    themeUUID: string;
    updatedAt: Date;
    tags: string;
  };
  $metadata: {
    totalRetryDelay: number;
    requestId: string;
    httpStatusCode: number;
    attempts: number;
  };
}

interface ManifestParam {
  type: 'draft' | 'review' | 'live' | 'scorm';
  tenantId: string;
  elearningId: string;
}

const manifestApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getManifest: build.query<ManifestResponse, ManifestParam>({
      query: (params) => ({
        url: config.getManifestURL,
        params,
      }),
      providesTags: [ManifestTag],
    }),
  }),
});

export const { useGetManifestQuery, useLazyGetManifestQuery } = manifestApi;
export default manifestApi;
